import styled from 'styled-components';

export const ForumTopic = styled.a`
  display: flex;
  flex-direction: column;
  color: ${p => p.theme.colors.staticBase700};
  line-height: 1;
`;

export const LastPost = styled.span`
  color: ${p => p.theme.colors.base400};
  line-height: 1.5;
`;
